import {
  CREATE_PASSWORD,
  CREATE_PASSWORD_FAILURE,
  CREATE_PASSWORD_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const createPasswordReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_PASSWORD:
      return { ...state, loading: true };
    case CREATE_PASSWORD_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case CREATE_PASSWORD_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default createPasswordReducer;
